// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__1p41u","empty__text":"styles_empty__text__2HVvm"};